import React from 'react';

import { CheckboxField } from '../../../helpers';

import { getBuyerProductSpecification, getProductName } from '../../../utils';


const QtyMultiplierConfirmDialog = (props) => {
    const { raisePOData, materialDetails, qtyMultiplierDeclaration, setQtyMultiplierDeclarataion } = props
    const { buyerPoItems } = raisePOData

    return (
        <div className="dispatch-note-list">
            <div className="custom-table-container">
                <table className="custom-product-table ml-2 mb-0 mt-2">
                    <thead>
                        <tr className="">
                            <th className="">SR NO.</th>
                            <th className="">MATERIAL ID</th>
                            <th className="">SPECIFICATIONS </th>
                            <th className="">QUANTITY MULTIPLIER</th>
                        </tr>   
                    </thead>
                    <tbody style={{ fontSize: "10px" }}>
                        {
                            buyerPoItems.map((eachBuyerPOItem, index) => {
                                const relatedMaterial = materialDetails.find(eachMaterial => eachMaterial.buyerReqItemId === eachBuyerPOItem.buyerReqItemId)

                                const customRowClassName = index % 2 === 0 ? "" : "custom-row-background"
                                return (
                                    <tr className={`${customRowClassName}`} >
                                        <td className="" style={{ textAlign: "center", padding:"4px", fontSize:"12px" }}>{index + 1}</td>
                                        <td className="" style={{ textAlign: "center", padding:"4px", fontSize:"12px" }}>{relatedMaterial.materialId}</td>
                                        <td className="" style={{ textAlign: "center", padding:"4px", fontSize:"12px" }}>
                                            <div className="ml-2">
                                                <span className="text-600 font-semibold">
                                                    {relatedMaterial?.companyProdName ? `${relatedMaterial?.companyProdName} | ` : `${relatedMaterial?.productName} | `}
                                                </span>
                                                <span className="text-xs">
                                                    {getBuyerProductSpecification(relatedMaterial?.companyProdSpec, relatedMaterial?.productSpecification, relatedMaterial?.UOM, relatedMaterial?.UOMValue)}
                                                </span>
                                            </div>
                                        </td>
                                        <td className="" style={{ textAlign: "center", padding:"4px", fontSize:"12px" }}>{eachBuyerPOItem.companyQtyMultiplier || 1}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table> 
            </div>
            <div className="flex flex-row m-3">
                <CheckboxField label="I acknowledge that all qty multiplier values for the items have been checked and verified." onChange={e => setQtyMultiplierDeclarataion(e.checked)} checked={qtyMultiplierDeclaration} style={{ textAlign: "center" }} />
            </div>
        </div>
    )
}

export default QtyMultiplierConfirmDialog;